
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { rtohrlyLoadsTbl } from '../Models/LoadsData';
import { RtoHrlyDemandService } from './rto-hrly-demand.service';

@Injectable({
  providedIn: 'root'
})
export class RtoHrlyDemandResolverService implements Resolve<Array<rtohrlyLoadsTbl>> {
  RtoloadsData: Observable<Array<rtohrlyLoadsTbl>>;
  constructor(private rtoHrlyLoadDemandSvc: RtoHrlyDemandService) { }
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<Array<rtohrlyLoadsTbl>> | Promise<Array<rtohrlyLoadsTbl>> | Array<rtohrlyLoadsTbl> {
    this.RtoloadsData = this.rtoHrlyLoadDemandSvc.GetRtoHrlyLoadDemand();
    return this.RtoloadsData;
  }
}
